import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { PermissionUtilityService } from '../services/permission-utility.service';

@Directive({
  selector: '[appPermission]'
})
export class PermissionDirective implements OnInit {

  @Input() permissionArray!: Array<Array<any>>;


  constructor(private elementRef: ElementRef, private permissionUtilityService: PermissionUtilityService) {
  }

  ngOnInit() {
    if (this.permissionArray.every((perm) => this.permissionUtilityService.checkPermissionsForSection(perm[0], perm[1]) === false)) {
      this.elementRef.nativeElement.style.display = 'none';
    }
  }
}

